// extracted by mini-css-extract-plugin
export var truncate = "_q-0";